import { takeLatest, call, put } from 'redux-saga/effects';
import employeeNoSessionApi from 'api/employee/employeeNoSessionApi';
import employeeApi from 'api/employee/employeeApi';
import * as termsActions from 'redux/ducks/Terms/TermsDucks';
import * as alertActions from 'redux/ducks/common/alertDucks';

export function* getNationList({ payload }) {
  try {
    const response = yield call(employeeNoSessionApi.getNationList, payload);
    yield put(termsActions.getNationListSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorMessage] }));
  }
}

export function* getTermsContents({ payload }) {
  try {
    let param = `${payload.langCd ? `langCd=${payload.langCd}` : ``}`;
    param = `${payload.trmsCd ? `${param}&trmsCd=${payload.trmsCd}` : `${param}`}`;
    param = `${payload.noSessionPrc === 'Y' ? `${param}&noSessionPrc=Y` : `${param}`}`;
    param = `${payload.trmsVerVal ? `${param}&trmsVerVal=${payload.trmsVerVal}` : `${param}`}`;
    const response = yield call(employeeNoSessionApi.getTermsContents, param);
    yield put(termsActions.getTermsContentsSuccess({ ...response, trmsCd: payload.trmsCd, lang: payload.langCd }));
  } catch (error) {
    // temp
    yield put(alertActions.open({ message: [error.errorMessage] }));
  }
}

export function* getPrivacyPolicy({ payload }) {
  try {
    let param = `${payload.langCd ? `langCd=${payload.langCd}` : ``}`;
    param = `${payload.trmsCd ? `${param}&trmsCd=${payload.trmsCd}` : `${param}`}`;
    param = `${payload.noSessionPrc === 'Y' ? `${param}&noSessionPrc=Y` : `${param}`}`;
    param = `${payload.trmsVerVal ? `${param}&trmsVerVal=${payload.trmsVerVal}` : `${param}`}`;
    const response = yield call(employeeNoSessionApi.getTermsContents, param);
    yield put(termsActions.getPrivacyPolicySuccess(response));
  } catch (error) {
    // temp
    yield put(alertActions.open({ message: [error.errorMessage] }));
  }
}

export function* getUseTerms({ payload }) {
  try {
    let param = `${payload.langCd ? `langCd=${payload.langCd}` : ``}`;
    param = `${payload.trmsCd ? `${param}&trmsCd=${payload.trmsCd}` : `${param}`}`;
    param = `${payload.noSessionPrc === 'Y' ? `${param}&noSessionPrc=Y` : `${param}`}`;
    param = `${payload.trmsVerVal ? `${param}&trmsVerVal=${payload.trmsVerVal}` : `${param}`}`;
    const response = yield call(employeeNoSessionApi.getTermsContents, param);
    yield put(termsActions.getUseTermsSuccess(response));
  } catch (error) {
    // temp
    yield put(alertActions.open({ message: [error.errorMessage] }));
  }
}

export function* getUseTermsVersion({ payload }) {
  try {
    let param = `${payload.langCd ? `langCd=${payload.langCd}` : ``}`;
    param = `${payload.trmsCd ? `${param}&trmsCd=${payload.trmsCd}` : `${param}`}`;
    param = `${payload.noSessionPrc === 'Y' ? `${param}&noSessionPrc=Y` : `${param}`}`;
    const response = yield call(employeeNoSessionApi.getTermsVersion, param);
    yield put(termsActions.getUseTermsVersionSuccess(response));
  } catch (error) {
    // temp
    yield put(alertActions.open({ message: [error.errorMessage] }));
  }
}

export function* getCountryTerms({ payload }) {
  try {
    let param = 'noSessionPrc=Y&';
    param = `${payload.langCd ? `${param}langCd=${payload.langCd}` : `${param}`}`;
    param = `${payload.cntryCd ? `${param}&cntryCd=${payload.cntryCd}` : `${param}`}`;
    param = `${payload.compAdminYn ? `${param}&compAdminYn=Y` : `${param}`}`;
    param = `${payload.reAgreementYn ? `${param}&reconsentYn=Y` : `${param}`}`;
    const response = yield call(employeeNoSessionApi.getCountryTerms, param);
    yield put(termsActions.getCountryTermsSuccess(response));
  } catch (error) {
    // temp
    yield put(alertActions.open({ message: [error.errorMessage] }));
  }
}

export function* getTermsPolicy({ payload }) {
  try {
    const response = yield call(employeeApi.getTermsPolicy, payload);
    yield put(termsActions.getTermsPolicySuccess(response));
  } catch (error) {
    yield put(termsActions.getTermsPolicyFail(error));
  }
}
export function* createTermsAgreement({ payload }) {
  try {
    const response = yield call(employeeNoSessionApi.createTermsAgreement, payload);
    yield put(termsActions.createTermsAgreementSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorMessage] }));
  }
}
export function* updatePrivacy({ payload }) {
  try {
    const response = yield call(employeeNoSessionApi.updatePrivacy, payload);
    yield put(termsActions.updatePrivacySuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorMessage] }));
  }
}

export function* getTermsVersionCntryCd({ payload }) {
  try {
    const response = yield call(employeeNoSessionApi.getTermsVersionCntryCd, payload);
    yield put(termsActions.getTermsPolicySuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorMessage] }));
  }
}

export default function* TermSaga() {
  yield takeLatest(termsActions.getNationList, getNationList);
  yield takeLatest(termsActions.getTermsContents, getTermsContents);
  yield takeLatest(termsActions.getPrivacyPolicy, getPrivacyPolicy);
  yield takeLatest(termsActions.getTermsPolicy, getTermsPolicy);
  yield takeLatest(termsActions.getCountryTerms, getCountryTerms);
  yield takeLatest(termsActions.getUseTermsVersion, getUseTermsVersion);
  yield takeLatest(termsActions.getUseTerms, getUseTerms);
  yield takeLatest(termsActions.createTermsAgreement, createTermsAgreement);
  yield takeLatest(termsActions.updatePrivacy, updatePrivacy);
  yield takeLatest(termsActions.getTermsVersionCntryCd, getTermsVersionCntryCd);
}
